import { useSelector, useDispatch } from 'react-redux';
import { editLanguage } from '../../redux/actions/language.actions';

const LangSwitcher = () => {
  const dispatch = useDispatch();
  const currentLang = useSelector((state) => state.language);

  const handleSwitchLang = () => {
    const languages = ['RU', 'SR', 'EN'];
    const currentIndex = languages.indexOf(currentLang);
    const newLanguage = languages[(currentIndex + 1) % languages.length];
    dispatch(editLanguage(newLanguage));
  };

  return (
    <div onClick={handleSwitchLang} className="switch-lang" style={{ marginTop: 'auto' }}>
      <div className="switch-circle-lang">{currentLang}</div>
    </div>
  );
};

export default LangSwitcher;
